import { EFaqsCategoryIcons } from '@/store/faq/config';

// INFO: The one declaration of the category order. Both the Example Question Shortcut Bar and the Filter Toolbar
// render from it, so the two sets can never drift apart.
export const CATEGORY_ORDER: EFaqsCategoryIcons[] = [
  EFaqsCategoryIcons.PERFORM,
  EFaqsCategoryIcons.KNOWLEDGE_QUESTIONS,
  EFaqsCategoryIcons.BUZZWORDS,
];

export const EXAMPLE_QUESTION_PANEL_ID = 'example-question-panel';

export const EXAMPLE_QUESTION_PANEL_TEST_IDS = {
  panel: 'example-question-panel',
  panelClose: 'example-question-panel-close',
  panelToggle: 'example-question-panel-toggle',
  panelSearch: 'example-question-panel-search',
  shortcutBar: 'example-question-shortcut-bar',
  categoryFilterPrefix: 'category-filter-',
  categoryShortcutPrefix: 'category-shortcut-',
} as const;

export const EXAMPLE_QUESTION_PANEL_MESSAGES = {
  shortcutBarIntro: 'chatPage.servicesSection.exemplary_questions.triggerLabel',
  shortcutBarToolbar: 'chatPage.questionPanel.shortcutBar.toolbarLabel',
  filterToolbar: 'chatPage.servicesSection.exemplary_questions.toolbarLabel',
  panelLabel: 'chatPage.sidebar.faq.label',
  panelClose: 'chatPage.questionPanel.close.label',
  panelToggle: 'chatPage.sidebar.faq.label',
} as const;
